import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Fairs} from 'api';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import moment from 'moment';
import * as actions from 'actions/fairs'

class FairBox extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  handleDelete(id, e) {
    if (confirm("Bạn có muốn xóa hội chợ này?")) {
      Fairs.actions.delete.request({ id }).then(response => {
        this.props.actionCallBack('Xóa thành công');
      });
    }
  }

  handlePublish(id, e) {
    e.preventDefault();
    if (confirm("Bạn có muốn công khai hội chợ này?")) {
      let data = {
        isPublish: true
      }
      Fairs.actions.update.request({ id }, data).then(response => {
        if(response && response.data) {
          this.props.actionCallBack('Công khai hội chợ thành công');
        }
      });
    }
  }

  handlePrivate(id, e) {
    e.preventDefault();
    if (confirm("Bạn có muốn ngừng công khai hội chợ này?")) {
      let data = {
        isPublish: false
      }
      Fairs.actions.update.request({ id }, data).then(response => {
        if(response && response.data) {
          this.props.actionCallBack('Ngừng công khai hội chợ thành công');
        }
      });
    }
  }

  openModal(content) {
    this.props.openModal(content)
  }

  goDetail(id) {
    this.props.history.push(`/fair/${id}`)
  }

  goEdit(id) {
    this.props.history.push(`/fair/${id}/edit`)
  }

  confirmDelete(id) {
    if (confirm("Bạn có muốn xóa hội chợ này không?")) {
      Fairs.actions.delete.request({id}).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Hội chợ đã được xóa");
        this.props.reload()
      });
    }
  }

  render() {
    let Item = this.props.data || {};
    let categories = Item.categories.map((item, index) => {
      if(index === 0) {return item.name} else {return ' - ' + item.name}
    })
    return (
      <tbody>
        <tr>
          <td style={{minWidth: 50, width: 50, textAlign: 'center'}}>{this.props.index}</td>
          <td style={{minWidth: 180, width: 180}}>{Item.name || ''}</td>
          <td style={{minWidth: 180}}>
            <p className='category'>{categories}</p>
            <p><a href='#' onClick={this.openModal.bind(this, Item.content)}>Xem quy chế</a></p>
          </td>
          <td style={{minWidth: 220, width: 220}}><p className={`${Item.isPublish === true ? 'publish' : ''} status`}>{actions.checkFairCategory(Item.status) || ''}{Item.status === 0 ? (Item.isPublish === true ? ' - Publish' : ' - Private') : ''}</p></td>
          <td style={{minWidth: 160, width: 160}}>{Item.startDate ? moment(Item.startDate).format('DD-MM-YYYY HH:mm') : ''}</td>
          <td style={{minWidth: 160, width: 160}}>{Item.endDate ? moment(Item.endDate).format('DD-MM-YYYY HH:mm') : ''}</td>
          <td style={{width: 182}} >
            <div className='wrap-btn-actions'>
              <button className="btn btn-action" type="button" onClick={this.confirmDelete.bind(this, Item.id)}>Xóa</button>&nbsp;&nbsp;
              <button className="btn btn-action" type="button" onClick={this.goDetail.bind(this, Item.id)}><i className='fa fa-eye' />Chi tiết</button>&nbsp;&nbsp;
              <button className="btn btn-action" type="button" onClick={this.goEdit.bind(this, Item.id)}><i className='fa fa-pencil' />Chỉnh sửa</button>&nbsp;&nbsp;
              {Item.status === 0 ? (Item.isPublish === true ?
                (<span className="btn btn-private" onClick={this.handlePrivate.bind(this, Item.id)}><i className='fa fa-times' />Private</span>) :
                (<span className="btn btn-publish" onClick={this.handlePublish.bind(this, Item.id)}><i className='fa fa-check' />Publish</span>)) : null}
            </div>
          </td>
        </tr>

      </tbody>
    );
  }
}

export default withRouter(connect()(FairBox));



// WEBPACK FOOTER //
// ./components/fair/FairBox.jsx